<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav [class]="extraClass" [canGoBack]="true" [title]="'Change Email'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-card>
      <form [formGroup]="emailForm" novalidate action="#">
        <tidy-row class="field-top-padding">
          <tidy-input
            formControlName="input"
            [label]="'What is your new email?'"
            [form]="emailForm.controls.input"
            type="email"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid Email'"
            [icon]="'assets/svg/mail-outline.svg'"
            [activeIcon]="'assets/svg/mail-outline-tidy-green.svg'">
          </tidy-input>
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-button
      item-right
      [action]="submitEmail.bind(this)"
      [text]="'Send Verification Email'"
      class="primary">
    </tidy-button>

    <tidy-error-message
      [text]="errorMessage">
    </tidy-error-message>

    <tidy-row [align]="'center'">
      <tidy-text [body]="'Check your Email for a verification link.'">
      </tidy-text>
    </tidy-row>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
